<template>
    <b-container>
        <h1>Add Policy</h1>
        <hr />
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.date_effective') }">
            <label for="date_effective">Effective Date</label>
            <DatePicker v-model="policy.date_effective" date-id="date_effective" />
            <div class="error-message">{{ validation.firstError('policy.date_effective') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.date_renewal') }">
            <label for="date_renewal">Renewal Date</label>
            <DatePicker v-model="policy.date_renewal" date-id="date_renewal" />
            <div class="error-message">{{ validation.firstError('policy.date_renewal') }}</div>
        </div>
        <label for="date_due">Balance Due Date</label>
        <DatePicker v-model="policy.date_due" date-id="date_due" />

        <label for="policy_term">Term of Policy (months)</label>
        <b-form-spinbutton id="policy_term" v-model="policy.policy_term" min="1" max="100"></b-form-spinbutton>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.policy_number') }">
            <label for="policy_number" class="mt-2">Policy Number</label>
            <b-form-input v-model="policy.policy_number" required placeholder="Enter the policy number"></b-form-input>
            <div class="error-message">{{ validation.firstError('policy.policy_number') }}</div>
        </div>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.policy_linesofcoverage_id') }">
            <label for="policy_linesofcoverage_id" class="mt-2">Line of Coverage</label>
            <b-form-select v-model="policy.policy_linesofcoverage_id" required
                :options="line_of_coverage"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.policy_linesofcoverage_id') }}</div>
        </div>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.coverage_line') }">
            <label for="coverage_line" class="mt-2">Coverage For</label>
            <b-form-select v-model="policy.coverage_line" required :options="coverage_line_codes"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.coverage_line') }}</div>
        </div>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.policy_types_id') }">
            <label for="policy_types_id" class="mt-2">Risk Type</label>
            <b-form-select v-model="policy.policy_types_id" required :options="risk_types"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.policy_types_id') }}</div>
        </div>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.description_of_risk') }">
            <label for="description_of_risk" class="mt-2">Description of Risk:</label>
            <b-form-textarea id="description_of_risk" required placeholder="Default textarea"
                v-model="policy.description_of_risk"></b-form-textarea>
            <div class="error-message">{{ validation.firstError('policy.description_of_risk') }}</div>
        </div>

        <h2 class="mt-4">Cost and Fees</h2>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.premium_total_term') }">
            <label for="premium_total_term" class="mt-2">Premium Total Term:</label>
            <b-form-input v-model="policy.premium_total_term" type="number"></b-form-input>
            <div class="error-message">{{ validation.firstError('policy.premium_total_term') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.policy_fees') }">
            <label for="inspection_fees" class="mt-2">Policy Fees:</label>
            <b-form-input v-model="policy.policy_fees" type="number"></b-form-input>
            <div class="error-message">{{ validation.firstError('policy.policy_fees') }}</div>
        </div>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.inspection_fees') }">
            <label for="inspection_fees" class="mt-2">Inspection Fees:</label>
            <b-form-input v-model="policy.inspection_fees" type="number"></b-form-input>
            <div class="error-message">{{ validation.firstError('policy.inspection_fees') }}</div>
        </div>
        <label for="ga_broker_fees" class="mt-2">General Agent Broker Fees:</label>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.ga_broker_fees') }">
            <b-form-input v-model="policy.ga_broker_fees" type="number"></b-form-input>
            <div class="error-message">{{ validation.firstError('policy.ga_broker_fees') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.stamp_fees') }">
            <label for="stamp_fees" class="mt-2">Stamp Fees:</label>
            <b-form-input v-model="policy.stamp_fees" type="number"></b-form-input>
            <div class="error-message">{{ validation.firstError('policy.stamp_fees') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.stamp_fees') }">
            <label for="tax_fees" class="mt-2">Tax Fees:</label>
            <b-form-input v-model="policy.tax_fees" type="number"></b-form-input>
            <div class="error-message">{{ validation.firstError('policy.tax_fees') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.broker_fee') }">
            <label for="broker_fee" class="mt-2">Broker Fees:</label>
            <b-form-input v-model="policy.broker_fee" type="number"></b-form-input>
            <div class="error-message">{{ validation.firstError('policy.broker_fee') }}</div>
        </div>
        <div class="my-3" v-if="pure_premium">
            <strong>Pure Premium:</strong> {{ pure_premium }}
        </div>
        <h2 class="mt-4">Commission</h2>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.commission_type') }">
            <label for="commission_type" class="mt-2">Commission Type:</label>
            <b-form-select v-model="policy.commission_type" :options="policy_commission_type_codes"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.commission_type') }}</div>
        </div>



        <label for="commission_percentage" class="mt-2">Commission Percentage:</label>
        <b-form-input v-model="policy.commission_percent" type="number"></b-form-input>
        <!-- <label for="commission_amount" class="mt-2">Commission Amount:</label>
        <b-form-input v-model="policy.commission_amount" type="number"></b-form-input> -->
        <div class="my-3" v-if="commission_amount_display">
            <strong>Commission Amount:</strong> {{ commission_amount_display }}
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.commission_status_id') }">
            <label for="commission_status" class="mt-2">Commission Status:</label>
            <b-form-select v-model="policy.commission_status_id"
                :options="policy_commission_status_codes"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.commission_status_id') }}</div>
        </div>
        <div class="my-3" v-if="net_income">
            <strong>Net income:</strong> {{ net_income }}
        </div>
        <div class="my-3" v-if="min_deposit">
            <strong>Minimum Deposit:</strong> {{ min_deposit }}
        </div>
        <h2 class="mt-4">Policy Details</h2>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.insurance_company_id') }">
            <label for="insurance_company_id" class="mt-2">Insurance Company:</label>
            <b-form-select v-model="insurance_company_id" :options="insurance_companies"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.insurance_company_id') }}</div>
        </div>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.general_agents_id') }">

            <label for="general_agents_id" class="mt-2">Agency:</label>
            <b-form-select v-model="agency_id" :options="agencies"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.general_agents_id') }}</div>
        </div>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.policy_status_id') }">
            <label for="policy_status_id" class="mt-2">Policy Status</label>
            <b-form-select v-model="policy.policy_status_id" required :options="policy_status_codes"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.policy_status_id') }}</div>
        </div>


        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.user_id') }">
            <label for="user_id" class="mt-2">Sales Agent:</label>
            <b-form-select v-model="policy.user_id" :options="users"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.user_id') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.writing_user_id') }">
            <label for="writing_user_id" class="mt-2">Renewal Processor:</label>
            <b-form-select v-model="policy.writing_user_id" :options="users"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.writing_user_id') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.servicing_user_id') }">
            <label for="servicing_user_id" class="mt-2">Customer Service:</label>
            <b-form-select v-model="policy.servicing_user_id" :options="users"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.servicing_user_id') }}</div>
        </div>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('policy.policy_source_id') }">
            <label for="policy_source_id" class="mt-2">Policy Source</label>
            <b-form-select v-model="policy.policy_source_id" required :options="policy_source_codes"></b-form-select>
            <div class="error-message">{{ validation.firstError('policy.policy_source_id') }}</div>
        </div>


        <label for="policy_source" class="mt-2">Business Source:</label>
        <b-form-select v-model="policy.policy_source" :options="policy_business_source_codes"></b-form-select>

        <label for="endorsement_note" class="mt-2">Endorsement Note:</label>
        <b-form-textarea id="textarea-default" placeholder="Endorsement Note"
            v-model="policy.endorsement_note"></b-form-textarea>
        <hr />
        <b-alert variant="danger" :show="validation.errors.length > 0">There are validation errors</b-alert>
        <b-button variant="primary" v-if="validation.errors.length === 0" @click="savePolicy" class="float-right">Save
            Policy</b-button>

    </b-container>
</template>

<script>
import ReferenceDataService from "@/services/ReferenceDataService";
import UserDataService from "@/services/UserDataService";
import SimpleVueValidation from 'simple-vue-validator';
import PolicyDataService from "@/services/PolicyDataService";
import DatePicker from '@/components/DatePicker.vue';

const Validator = SimpleVueValidation.Validator;

export default {
    components: {
        DatePicker
    },
    name: "PolicyForm",
    data() {
        return {
            policy: {
                aspect_id: null,
                agent_name: null,
                broker_fee: 0,
                business_type_name: null,
                commission_amount: null,
                commission_percent: null,
                commission_status_id: 1,
                commission_type: null,
                coverage_line: 1,
                date_due: '',
                date_effective: '',
                date_renewal: '',
                description_of_risk: null,
                ga_broker_fees: 0,
                general_agents_id: null,
                insurance_company_id: null,
                inspection_fees: 0,
                insurance_name: null,
                json_search: null,
                label: 'none',
                lineofcoverage_name: 'Undefined',
                location_id: 1,
                meta: null,
                payment_total: null,
                policy_fees: 0,
                policy_linesofcoverage_id: 1,
                policy_number: 'TBD',
                policy_parent: null,
                policy_renewal: null,
                policy_source_id: null,
                policy_source_key: 'todo',
                policy_source_name: 'Unassigned',
                policy_status_id: 1,
                policy_term: 12,
                policy_type_name: 'Unassigned',
                policy_type: 'Unassigned',
                policy_types_id: 1,
                premium_total_term: 0,
                servicing_user_id: null,
                stamp_fees: 0,
                tax_fees: 0,
                user_id: null,
                users_name: null,
                writing_user_id: null,
            },
            users: [],
            validation_message: null,
            line_of_coverage: [],
            coverage_line_codes: [],
            risk_types: [],
            policy_status_codes: [],
            policy_source_codes: [],
            policy_commission_type_codes: [],
            policy_business_source_codes: [],
            insurance_companies: [],
            agencies: [],
            agency_id: null,
            insurance_company_id: null,
            pure_premium: null,
            commission_amount: null,
            commission_amount_display: null,
            min_deposit: null,
            net_income: null,
        };
    },
    validators: {
        'policy.policy_number': function (value) {
            return Validator.value(value).required('The policy number is required');
        },
        'policy.date_effective': function (value) {
            return Validator.value(value).required('The date effective is required');
        },
        'policy.broker_fee': function (value) {
            return Validator.value(value).required('The broker fee is required');
        },
        'policy.ga_broker_fees': function (value) {
            return Validator.value(value).required('The general agent broker fee is required');
        },
        'policy.inspection_fees': function (value) {
            return Validator.value(value).required('The inspection fee is required');
        },
        'policy.policy_fees': function (value) {
            return Validator.value(value).required('The policy fees is required');
        },
        'policy.premium_total_term': function (value) {
            return Validator.value(value).required('The premium total term is required');
        },
        'policy.stamp_fees': function (value) {
            return Validator.value(value).required('The stamp fees is required');
        },
        'policy.tax_fees': function (value) {
            return Validator.value(value).required('The tax fees is required');
        },
        'policy.commission_status_id': function (value) {
            return Validator.value(value).required('The commission status id is required');
        },
        'policy.date_renewal': function (value) {
            return Validator.value(value).required('The date renewal is required');
        },
        'policy.commission_type': function (value) {
            return Validator.value(value).required('The commission type is required');
        },
        'policy.policy_linesofcoverage_id': function (value) {
            return Validator.value(value).required('The lines of coverage is required');
        },
        'policy.coverage_line': function (value) {
            return Validator.value(value).required('The coverage line is required');
        },
        'policy.policy_types_id': function (value) {
            return Validator.value(value).required('The risk type is required');
        },
        'policy.policy_status_id': function (value) {
            return Validator.value(value).required('The status is required');
        },
        'policy.policy_source_id': function (value) {
            return Validator.value(value).required('The policy source is required');
        },
        'policy.user_id': function (value) {
            return Validator.value(value).required('The Sales agent is required');
        },
        'policy.writing_user_id': function (value) {
            return Validator.value(value).required('The Renewal Processor agent is required');
        },
        'policy.servicing_user_id': function (value) {
            return Validator.value(value).required('The Customer Service agent is required');
        },
        'policy.description_of_risk': function (value) {
            return Validator.value(value).required('The Description of Risk is required');
        },
        'policy.general_agents_id': function (value) {
            return Validator.value(value).required('The Agency is required');
        },
        'policy.insurance_company_id': function (value) {
            return Validator.value(value).required('The Insurance Company is required');
        },
    },
    created() {

        Promise.all([

        ReferenceDataService.policy_linesofcoverage().then((res) => {
            if (res && res.data) this.line_of_coverage = res.data;
        }),
        ReferenceDataService.policy_risktype_codes().then((res) => {
            if (res && res.data) this.risk_types = res.data;
        }),
        ReferenceDataService.insurance_companies().then((res) => {
            if (res && res.data) this.insurance_companies = res.data;
        }),
        ReferenceDataService.agencies().then((res) => {
            if (res && res.data) this.agencies = res.data;
        }),
        UserDataService.getActiveUsers().then((res) => {
            if (res && res.data) this.users = res.data;
        })
    ]).then(() => {
        // Set synchronous reference data
        this.policy_status_codes = ReferenceDataService.policy_status_codes().map(
            (obj) => ({
                value: obj.id,
                text: obj.label,
            })
        );
        this.policy_source_codes = ReferenceDataService.policy_source_codes();
        this.policy_business_source_codes = ReferenceDataService.policy_business_source_codes();
        this.coverage_line_codes = ReferenceDataService.policy_coverageline_codes();
        this.policy_commission_type_codes = ReferenceDataService.policy_commission_type_codes();
        this.policy_commission_status_codes = ReferenceDataService.policy_commission_status_codes();
        this.$validate();
    }).catch((err) => {
        console.error('Failed to load reference data:', err);
    })

        if (this.$route.query.aspect_id !== undefined) {
            this.policy.aspect_id = this.$route.query.aspect_id            
        }

        const today = new Date();
        const nextMonth = new Date(today);
        nextMonth.setMonth(today.getMonth() + 1);

        const nextYear = new Date(today);
        nextYear.setFullYear(today.getFullYear() + 1);

        this.policy.date_due = this.toMMDDYYYY(nextMonth);
        this.policy.date_effective = this.toMMDDYYYY(today);
        this.policy.date_renewal = this.toMMDDYYYY(nextYear);

        
    },
    watch: {
        agency_id: function (val) {
            this.policy.general_agents_id = val
        },
        insurance_company_id: function (val) {
            this.policy.insurance_company_id = val
        },
        'policy.policy_linesofcoverage_id': function () {

            this.line_of_coverage.forEach(item => {

                if (item.value == this.policy.policy_linesofcoverage_id) {

                    this.policy.lineofcoverage_name = item.text
                }
            });

        },
        'policy.policy_types_id': function () {

            this.risk_types.forEach(item => {

                if (item.value == this.policy.policy_types_id) {

                    this.policy.policy_type = item.text
                }
            });

        },

        policy: function () {
            this.$validate()
        }
    },
    methods: {

        toMMDDYYYY(dateObj) {
            const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
            const dd = String(dateObj.getDate()).padStart(2, "0");
            const yyyy = dateObj.getFullYear();
            return `${mm}/${dd}/${yyyy}`;
        },

        savePolicy: function () {

            this.$validate();

            if (this.validation.errors.length > 0) {
                return;
            }

            PolicyDataService.create(this.policy).then(async (res) => {
                let policyId = null;
                if (res && res.data && res.data.id) {
                    policyId = res.data.id;
                } else if (res && res.id) {
                    policyId = res.id;
                } else if (typeof res === 'string') {
                    policyId = res;
                }

                if (policyId) {
                    // Auto-link to aspect if aspect_id is in URL
                    const aspectId = this.$route.query.aspect_id;
                    if (aspectId) {
                        try {
                            await PolicyDataService.linkToAspect(policyId, aspectId, 'Insured');
                        } catch (e) {
                            console.error('Failed to auto-link aspect:', e);
                        }
                    }
                    window.location = `/policy/${policyId}?update=true`;
                } else {
                    console.error('Failed to create policy:', res?.message || 'Unknown error');
                    this.$emit("error", res?.message || 'Failed to create policy');
                }
            }).catch((err) => {
                console.log(err);
                this.$emit("error", err);
            })

        },

        roundMoney: function (num) {
            num = parseFloat(num);
            let result = Math.round(num * 100);
            return (result / 100).toFixed(2);
        },
        doCalcs: function () {
            let premium = parseFloat(this.policy.premium_total_term); // do this
            let inspection_fees = parseFloat(this.policy.inspection_fees);
            let ga_broker_fees = parseFloat(this.policy.ga_broker_fees);
            let stamp_fees = parseFloat(this.policy.stamp_fees);
            let tax_fees = parseFloat(this.policy.tax_fees);
            let policy_fees = parseFloat(this.policy.policy_fees);
            let broker_fee = parseFloat(this.policy.broker_fee);

            let all_fees =
                stamp_fees +
                policy_fees +
                broker_fee +
                inspection_fees +
                ga_broker_fees +
                tax_fees;

            this.pure_premium = "$" + this.roundMoney(premium - all_fees);

            let PolicyCommissionType = this.policy.commission_type;
            if (PolicyCommissionType === "percent") {
                this.test_calc = true;

                let commission_percent = parseFloat(this.policy.commission_percent);
                this.commission_amount_display =
                    "$" +
                    this.roundMoney((premium - all_fees) * commission_percent * 0.01);
                this.net_income =
                    "$" +
                    this.roundMoney(
                        (premium - all_fees) * commission_percent * 0.01 + broker_fee
                    );
            } else {
                this.net_income =
                    "$" +
                    this.roundMoney(
                        parseFloat(this.policy.commission_amount) + broker_fee
                    );
            }

            this.min_deposit =
                "$" +
                this.roundMoney(
                    (premium - stamp_fees - policy_fees - broker_fee) * 0.35 +
                    policy_fees +
                    stamp_fees +
                    broker_fee
                );
        },
    },
};
</script>